import axios from "axios";
import API from "../api";

export const MenuTagsModule = {
  state: {
    menuTags: [],
    isRequesting: false,
    errored: false,
    error: ""
  },
  actions: {
    getMenuTags({
      commit
    }) {
      return new Promise(async (resolve, reject) => {
        commit("getMenuTagsRequest");
        return axios
          .get(`${API.BASE_URL}${API.MENU_TAGS}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("getMenuTagsSuccess", response.data);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("menuTagTagError", error);
            reject(error);
          });
      });
    },
    createMenuTag({
      commit
    }, record) {
      return new Promise(async (resolve, reject) => {
        commit("createMenuTagRequest");
        return axios
          .post(`${API.BASE_URL}${API.MENU_TAGS}`, record, API.RequestHeaders())
          .then(response => {
            if (response.status === 201) {
              commit("createMenuTagSuccess", response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("menuTagError", error);
            reject(error);
          });
      });
    },
    deleteMenuTag({
      commit
    }, recordId) {
      return new Promise(async (resolve, reject) => {
        commit("deleteMenuTagRequest");
        return axios
          .delete(`${API.BASE_URL}${API.MENU_TAGS}/${recordId}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("deleteMenuTagSuccess", recordId);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("menuTagError", error);
            reject(error);
          });
      });
    }
  },
  mutations: {
    getMenuTagsRequest(state) {
      state.isRequesting = true;
    },
    getMenuTagsSuccess(state, payload) {
      state.menuTags = payload;
      state.isRequesting = false;
    },
    createMenuTagRequest(state) {
      state.isRequesting = true;
    },
    createMenuTagSuccess(state, payload) {
      state.menuTags.push(payload);
      state.isRequesting = false;
    },
    menuTagError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    deleteMenuTagRequest(state) {
      state.isRequesting = false;
    },
    deleteMenuTagSuccess(state, recordId) {
      const deletedRecord = state.menuTags.find(
        menuTag => menuTag.id === recordId
      );
      const currentIndex = state.menuTags.indexOf(deletedRecord);
      state.menuTags.splice(currentIndex, 1);
      state.isRequesting = false;
    }
  },
  getters: {
    getMenuTags(state) {
      return state.menuTags;
    }
  }
};